import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export function scoreBucketClass(score: number): string {
  if (score >= 8) return 'bg-green-100 text-green-700'
  if (score >= 5) return 'bg-amber-100 text-amber-700'
  return 'bg-slate-100 text-slate-700'
}

interface LeadScoreBadgeProps {
  score: number | null
  reasoning?: string
}

/** 1–10 conversion score pill for the lead list. Muted dash when unscored. */
export function LeadScoreBadge({ score, reasoning }: LeadScoreBadgeProps) {
  if (score == null) {
    return (
      <span className="text-muted-foreground inline-flex h-6 w-6 items-center justify-center text-sm">—</span>
    )
  }
  const badge = (
    <span
      className={cn(
        'inline-flex h-6 w-6 items-center justify-center rounded-full text-sm font-semibold',
        scoreBucketClass(score)
      )}
      aria-label={`Conversion score ${score} of 10`}
    >
      {score}
    </span>
  )
  if (!reasoning) return badge
  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent className="max-w-xs">{reasoning}</TooltipContent>
    </Tooltip>
  )
}
